import React, { useEffect, useState } from 'react';
import {
  Container,
  Option,
  OptionWrapper,
  SubTable,
  SubTableCell,
  Table,
  TeamCell,
  Title
} from './styled';
import { observer } from 'mobx-react';
import { toJS } from 'mobx';
import SportsTeamLogo from '../../../../../../components/teamLogo';

const TeamRanking = observer(({ data }) => {
  const { tabs, rankList, selectedTab, setSelectedTab, homeId, awayId } = data;

  const handleChangeSelectTab = (tab) => {
    setSelectedTab(tab);
    setSelectedTab(tab);
  };

  if (rankList.length === 0) {
    return null;
  }

  return (
    <Container>
      <Title>
        팀 순위
        <OptionWrapper>
          {tabs.map((item, idx) => {
            return (
              <Option
                key={idx}
                isSelected={selectedTab === item.key}
                onClick={() => handleChangeSelectTab(item.key)}
              >
                {item.value}
              </Option>
            );
          })}
        </OptionWrapper>
      </Title>
      <Table>
        <colgroup>
          <col width={45} />
          <col width={115} />
        </colgroup>

        <tbody>
          <tr>
            <th>순위</th>
            <th>팀명</th>
            <SubTableCell rowSpan={rankList.length + 1}>
              <SubTableComp list={rankList} />
            </SubTableCell>
          </tr>
          {rankList.length > 0 &&
            rankList.map((value, key) => {
              const { ranking, teamName, teamEmblemPath } = value;

              return (
                <tr key={key}>
                  <td>{ranking}</td>
                  <td>
                    <TeamCell>
                      {teamEmblemPath !== '' && (
                        <SportsTeamLogo
                          imgSize={'20'}
                          imgUrl={teamEmblemPath}
                          isLazy={false}
                        />
                      )}
                      <div>{teamName}</div>
                    </TeamCell>
                  </td>
                </tr>
              );
            })}
        </tbody>
      </Table>
    </Container>
  );
});

const SubTableComp = ({ list }) => {
  return (
    <SubTable>
      <colgroup>
        <col width={45} />
        <col width={45} />
        <col width={45} />
        <col width={45} />
        <col width={45} />
      </colgroup>
      <tbody>
        <tr>
          <th>경기</th>
          <th>승점</th>
          <th>승</th>
          <th>무</th>
          <th>패</th>
        </tr>
        {list.map((value, key) => {
          const { gameCount, winPoint, winCount, lossCount, drawCount } = value;
          return (
            <tr key={key}>
              <td>{gameCount}</td>
              <td>{winPoint}</td>
              <td>{winCount}</td>
              <td>{drawCount}</td>
              <td>{lossCount}</td>
            </tr>
          );
        })}
      </tbody>
    </SubTable>
  );
};

export default TeamRanking;
